export default __webpack_public_path__ + "static/media/upee_chanels.41766257.webp";